import React, { useState, useEffect, useMemo, createContext } from 'react';
import { Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import moment from 'moment';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation } from 'react-router-dom';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { useAppContext } from 'providers/AppProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import OrderHistoryModalParent from './OrderHistoryModalParent';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import DatePicker from 'react-datepicker';
import SetMastersDetails from 'components/common/SetMastersDetails';
import RemoveMasters from 'components/common/RemoveMasters';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';


const OrderHistory = () => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(true);
  const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
  const [options] = useState(facilityList);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState(facilityList[0]);
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, 'months').startOf('day').format('MM/DD/YYYY'),
    endDate: moment().endOf('day').format('MM/DD/YYYY'),
    facility: facilityList[0].value,
  });
  const [selectedOrder, setSelectedOrder] = useState(null);
  const location = useLocation();
  // const location = {
  //   pathname: "/main/peltask/orderhistory",
  //   search: "?facility=35&from=12/06/2025&to=01/06/2026&order=22910",
  //   hash: "",
  //   state: null,
  //   key: "xyz789"
  // };

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const facility_id = searchParams.get('facility');
  const fromDate = searchParams.get('from');
  const toDate = searchParams.get('to');
  const orderId = searchParams.get('order');
  const notificationId = searchParams.get('id');

  const {
    config: { isFluid, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();


  const columns = [
    {
      accessorKey: 'patient',
      header: 'Patient',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'ordertypetable',
      header: 'Order Type',
      meta: {
        headerProps: { className: 'text-900 text-center' },
        cellProps: { className: 'text-center' }
      }
    },
    {
      accessorKey: 'drug',
      header: 'Drug',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'qty',
      header: 'Qty',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'createdby',
      header: 'Created By',
      meta: {
        headerProps: { className: 'text-900 text-start' }
      }
    },
    {
      accessorKey: 'createddate',
      header: 'Created Date',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'deliverydate',
      header: 'Delivery Date',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'deliverynumber',
      header: 'Delivery No',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'orderstatusTable',
      header: 'Order Status',
      meta: {
        headerProps: { className: 'text-900 text-center' },
        cellProps: { className: 'text-center' }
      }
    },
    {
      accessorKey: 'signature',
      header: 'Signature',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'details',
      header: 'Details',
      meta: {
        headerProps: { className: 'text-900 text-center' },
        cellProps: { className: 'text-center fw-bold' }
      },
      cell: ({ row: { original } }) => {
        return (
          <Link
            onClick={() => {
              setSelectedOrder(original);
              setShow(true);
            }}
          >
            <FontAwesomeIcon icon="eye" className={original?.order_from == 2 ? "text-danger" : "text-primary"} />
          </Link>
        )
      }

      // cell: ({ row: { original } }) => (
      //   <Link
      //     onClick={() => {
      //       setShow(true);
      //       navigate(
      //         `/main/peltask/orderhistory/${filters.facility}/${filters.startDate}/${filters.endDate}/${original.orderid}`,
      //         { state: { original } }
      //       );
      //     }}
      //   >
      //     <FontAwesomeIcon
      //       icon="eye"
      //       className={original?.order_from == 2 ? "text-danger" : "text-primary"}
      //     />
      //   </Link>
      // )
    }
  ]

  // const fetchTable = async () => {
  const fetchTable = async (fromUrl = false, overrideFilters = null) => {
    setIsLoading(true);
    setApiError(false);

    const activeFilters = overrideFilters || filters;

    const payload = {
      facility_id: activeFilters.facility,
      from_date: activeFilters.startDate,
      to_date: activeFilters.endDate
    };

    try {
      const token = localStorage.getItem('accessToken');
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/orders/order-history/`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const orders = res.data.orders || [];
      if (orders.length === 0) {
        setFilteredData([]);
        setIsLoading(false);
        return;
      }

      const orderType = JSON.parse(localStorage.getItem('order_types')) || {};
      const orderStatus = JSON.parse(localStorage.getItem('order_status_facility')) || {};

      const results = orders.map(iterator => ({
        orderid: iterator.id,
        patient: iterator.patient_lastname && iterator.patient_firstname
          ? `${iterator.patient_lastname}, ${iterator.patient_firstname}`
          : "-",
        facilityid: iterator.facility_id || "-",
        ordertype: iterator.order_type || "-",
        ordertypetable: iterator.order_from == 1
          ? (orderType[iterator.order_type] || "New Patient")
          : (iterator.order_type || "-"),
        deliverydate: iterator.delivery_date
          ? moment(iterator.delivery_date).format('MM/DD/YY')
          : "-",
        reason: iterator.discarded_reason || "-",
        refillrequest: iterator.refill_request || "-",
        createdby: iterator.order_from == 2 ? 'System' : iterator.created_by || "-",
        createddate: iterator.created
          ? moment(iterator.created).format('MM/DD/YY')
          : "-",
        orderstatusTable: orderStatus[iterator.order_status] || iterator.order_status || "-",
        orderstatus: iterator.order_status || "-",
        rxnumber: iterator.pharmacy_order_id || "-",
        qty: parseFloat(iterator.drug_qty).toFixed(2) || "-",
        drug: iterator.drug || "-",
        notesObj: iterator.notes || "-",
        deliverynumber: iterator.delivery_no || "-",
        direction: iterator.directions || "-",
        order_from: iterator.order_from || "-",
        prescription: "-",
        createdDateRaw: iterator.created ? new Date(iterator.created) : null,
        documents: iterator.documents
      }));

      results.sort((a, b) => (b.createdDateRaw || 0) - (a.createdDateRaw || 0));

      setData(results);
      setFilteredData(results);

      if (fromUrl && orderId) {
        const match = results.find(
          r => String(r.orderid) === String(orderId)
        );

        if (match) {
          setSelectedOrder(match);   // 🔑 pass row data
          setShow(true);             // 🔑 open modal
        }
      }


    } catch {
      setApiError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const searchByDate = async () => {
    try {
      fetchTable()
    } catch (error) {
      console.error('Error fetching data by date:', error);
      toast.error('Failed to fetch data by date');
    }
  };

  const table = useAdvanceTable({
    data: filteredData,
    columns,
    selection: false,
    sortable: true,
    pagination: true
  });

  useEffect(() => {
    setConfig('isFluid', true);
    setConfig('isNavbarVerticalCollapsed', true);
    SetMastersDetails();

    if (facility_id && fromDate && toDate) {
      const urlFilters = {
        facility: Number(facility_id),
        startDate: fromDate,
        endDate: toDate
      };

      setFilters(prev => ({ ...prev, ...urlFilters }));
      setSelectedFacility(facilityList.find(f => f.value == facility_id));
      fetchTable(true, urlFilters);
    } else {
      fetchTable();
    }

    return () => {
      setConfig('isFluid', false);
      setConfig('isNavbarVerticalCollapsed', false);
      RemoveMasters();
    };
  }, []);



  // useEffect(() => {
  //   setConfig('isFluid', true);
  //   setConfig('isNavbarVerticalCollapsed', true);
  //   fetchData();
  //   SetMastersDetails();

  //   return () => {
  //     setConfig('isFluid', false);
  //     setConfig('isNavbarVerticalCollapsed', false);
  //     RemoveMasters();
  //   }
  // }, []);

  const fetchData = async () => {
    try {
      // let sendingObj = {
      //   "masters": ["order_types", "order_status", "delivery_types"]
      // }
      // let tokenStr = localStorage.getItem("accessToken");
      // const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/orders/fetch-masters", sendingObj, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
      // let objData = data.masters
      // let orderTypesResult = objData.order_types.reduce((obj, item) => {
      //   obj[item.id] = item.order_type;
      //   return obj;
      // }, {});

      // let orderStatusResult = objData.order_status.reduce((obj, item) => {
      //   obj[item.id] = item.order_status;
      //   return obj;
      // }, {});

      // let orderStatusResultInternal = objData.order_status.map(item => ({
      //   key: item.order_status,
      //   value: item.id
      // }));
      // localStorage.setItem("order_status_internal", JSON.stringify(orderStatusResultInternal))
      // localStorage.setItem("order_status", JSON.stringify(orderStatusResult))
      // localStorage.setItem("order_types", JSON.stringify(orderTypesResult))

      fetchTable();

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFieldChange = (e) => {
    setSelectedFacility(e)
    setFilters({
      ...filters,
      "facility": e.value
    });
  };

  async function handleSearch(e) {
    e.preventDefault();
    if (filters.startDate && filters.endDate) {
      await searchByDate();
    }
  };

  const validateExpiryDate = date => {
    if (moment(date) > moment(filters.startDate)) {
      handleInputChange({ target: { name: 'endDate', value: moment(date).format("MM/DD/YYYY") } })
    } else {
      toast.error("End date should be greater than Start Date");
    }
  }

  const breadcrumbItems = [
    { name: 'Dashboard', href: '/main', isActive: false },
    { name: 'Order', href: '#', isActive: true },
    { name: 'Order History', href: "#", isActive: true }
  ];

  return (
    <>
      <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
      <OrderHistoryModalParent
        show={show}
        handleClose={() => {
          setShow(false);
          setSelectedOrder(null);
        }}
        filteredData={filteredData}
        selectedOrder={selectedOrder}
        setRefresh={setFilteredData}
      />
      <Card className="p-3">
        <h4 className="mb-3">Order History</h4>
        <div className="border rounded pb-4  p-3 mb-3">
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Facility</Form.Label>
                <ThemedSelect
                  name="facility"
                  closeMenuOnSelect={true}
                  placeholder='Select Facility'
                  classNamePrefix="react-select"
                  options={options}
                  value={selectedFacility}
                  getOptionLabel={option => option.key}
                  getOptionValue={option => option.value}
                  onChange={handleFieldChange}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#80bdff" },
                    }),
                    option: (provided, { isFocused, isSelected }) => ({
                      ...provided,
                      backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                      color: isSelected ? "#212529 !important" : "#212529 !important",
                      cursor: "pointer",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#212529",
                    }),
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Start Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"

                  selected={filters.startDate ? moment(filters.startDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    handleInputChange({ target: { name: 'startDate', value: moment(date).format("MM/DD/YYYY") } })
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>End Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"

                  selected={filters.endDate ? moment(filters.endDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    validateExpiryDate(date)
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button variant="primary" onClick={handleSearch} className="me-2">
                Search
              </Button>
            </Col>
          </Row>
        </div>
      </Card>
      {isLoading ? (
        <ShimmerUI />
      ) : apiError ? (
        <Alert variant="danger" className="text-center fw-bold">
          Failed to fetch order history. Please try again later.
        </Alert>
      ) : filteredData.length === 0 ? (
        <Alert variant="info" className="text-center fw-bold">
          No order history found for the selected facility and date range.
        </Alert>
      ) : (
        <Card className="p-3">
          <AdvanceTableProvider {...table}>
            <Row>
              <Col xs="4" className="mb-2 view-patient-search-holder">
                <AdvanceTableSearchBox placeholder="Search..." />
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <AdvanceTable
                  headerClassName="bg-200 text-nowrap align-middle text-center"
                  rowClassName="text-nowrap align-middle text-center"
                  tableProps={{
                    size: 'sm',
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Card.Footer>
                <div className="mt-3">
                  <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                </div>
              </Card.Footer>
            </Row>
          </AdvanceTableProvider>
        </Card>
      )}
    </>
  );
};

export default OrderHistory;
